import React, { Component } from 'react';
import { bool, element, func, number, string, shape } from 'prop-types';
import { Mic, PlaylistPlay, Radio } from '@material-ui/icons';
import { TYPE_LIVE_READ, TYPE_WATCHLIST } from '../../CreativeAnalytics/constants';
import cx from 'classnames';
import styles from './styles.scss';
import { NEW_AD_USERS } from '../constants';

export default class TableRow extends Component {
  static propTypes = {
    data: shape({
      title: string,
      typeId: number,
      avgAdCost: number,
      ads: number,
      adUser: number,
      adVisit: number,
      visitOfAds: number,
      newAdUsers: number,
      newAdUsersOfAds: number,
    }),
    onCellClick: func,
    preRecordedIcon: element,
    liveReadsIcon: element,
    watchlistIcon: element,
    isAvgCostDisabled: bool,
    isCustomReport: bool,
    isShowNewAdUsers: bool,
  };

  static defaultProps = {
    data: {},
    preRecordedIcon: <Radio/>,
    liveReadsIcon: <Mic/>,
    watchlistIcon: <PlaylistPlay/>
  };

  getAdTypeIcon() {
    const {
      data,
      liveReadsIcon,
      preRecordedIcon,
      watchlistIcon,
    } = this.props;
    const { typeId } = data;
    let adTypeIcon;

    switch (typeId) {
      case TYPE_LIVE_READ.id:
        adTypeIcon = liveReadsIcon;
        break;
      case TYPE_WATCHLIST.id:
        adTypeIcon = watchlistIcon;
        break;
      default:
        adTypeIcon = preRecordedIcon;
    }

    return adTypeIcon;
  }

  render() {
    const { data, onCellClick, isAvgCostDisabled, isCustomReport, isShowNewAdUsers } = this.props;
    const { title, ads, adVisit, visitOfAds, avgAdCost, newAdUsersOfAds, newAdUsers } = data;
    const formattedAdVisit = parseFloat(adVisit.toFixed(1));
    const localeAvgAdCost = avgAdCost == null ? 'N/A' : `$${avgAdCost.toFixed(2).toLocaleString()}`;
    const adTypeIcon = this.getAdTypeIcon();
    const tableCellClasses = isCustomReport ? cx(styles.tableCell, styles.customTableCell) : styles.tableCell;
    // TODO: Replace row with adUser when implemented and selected from dropdown.

    return (
      <div data-test="adTypeTableRow" className={styles.tableRow}>
        <div className={tableCellClasses}>
          <span className={styles.typeIcon}>{adTypeIcon}</span>
          <span data-test="adTypeTableName" className={styles.typeName}>{title}</span>
        </div>
        {isShowNewAdUsers ? (
          <div data-test="adTypeTableNewAdUsers" className={tableCellClasses}
             onClick={onCellClick({ data, key: NEW_AD_USERS })}>{newAdUsers.toLocaleString()}</div>
        ) : (
          <div data-test="adTypeTableAdVisits" className={tableCellClasses}
             onClick={onCellClick({ data, key: 'adVisit' })}>{formattedAdVisit.toLocaleString()}</div>
        )}
        {/* <div className={styles.tableCell} onClick={onCellClick({data, key: 'adUser'})}>{adUser.toLocaleString()}</div> */}
        <div data-test="adTypeTableAds" className={tableCellClasses} onClick={onCellClick({ data, key: 'ads' })}>{ads.toLocaleString()}</div>
        {isShowNewAdUsers ? (
          <div data-test="adTypeTableNewAdUsersOfAds" className={tableCellClasses}
             onClick={onCellClick({ data, key: 'newAdUsersOfAds' })}>{parseFloat(newAdUsersOfAds.toFixed(2)).toLocaleString()}</div>
        ) : (
          <div data-test="adTypeTableAdvisitsAds" className={tableCellClasses}
             onClick={onCellClick({ data, key: 'visitOfAds' })}>{parseFloat(visitOfAds.toFixed(2)).toLocaleString()}</div>
        )}
        {
          !isAvgCostDisabled &&
          <div data-test="adTypeTableAvgAdCost" className={tableCellClasses} onClick={onCellClick({ data, key: 'avgAdCost' })}>{localeAvgAdCost}</div>
        }
      </div>
    );
  }
}
